// extracted by mini-css-extract-plugin
module.exports = {"v1x160j6":"v1x160j6","c1n5hs9b":"c1n5hs9b","tn6a5v3":"tn6a5v3"};